// withApollo.js
import React, { createContext, useContext } from 'react';
import { ApolloClient, ApolloLink, InMemoryCache, HttpLink } from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { logOut, getAccessToken } from '../../utils/awsAuth';
import { navigate } from '../../hoc/withNavigation';
import { publicRuntimeConfig } from 'config';

const { GRAPHQL_URL, metadata, settings } = publicRuntimeConfig;

const ApolloContext = createContext();

if (!settings.isProd) console.log('metadata', GRAPHQL_URL, metadata, settings);

const authMiddleware = setContext(operation =>
    getAccessToken().then(token => {
        return {
            headers: {
                Authorization: token ? `Bearer ${token}` : ''
            }
        };
    })
);

const httpLink = new HttpLink({ uri: GRAPHQL_URL });

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, extensions, path }) => {
                console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);

                switch (extensions.code) {
                    case 'UNAUTHENTICATED':
                        logOut().then(() => navigate('/')).catch(() => navigate('/'));
                        break;
                    default:
                        break;
                }
            }
        );
    }

    if (networkError) {
        console.log(`[Network error]: ${networkError}`);
    }
});

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, authMiddleware, httpLink]),
    cache: new InMemoryCache()
});

const ApolloProviderWrapper = ({ children }) => (
    <ApolloProvider client={client}>
        <ApolloContext.Provider value={client}>{children}</ApolloContext.Provider>
    </ApolloProvider>
);

export default ApolloProviderWrapper;

export { client };


export const useApollo = () => useContext(ApolloContext);
